import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { getIsReportNameExists } from '../../api/report-designer';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { saveReport } from '../actions/report-designer.actions';
import { validateReportNameOnBlur } from '../utils/validation.utils';

const useStyles = makeStyles({
  modal: {
    width: 650,
  },
  confirmModal: {
    '& [class*="MuiDialogContent-root"]': {
      paddingBottom: 5,
    },
  },
});

const SaveAsModal = ({ isOpen, initialReportName, handleClose, setIsLoading }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [reportNameForSave, setReportName] = useState(initialReportName);
  const [error, setError] = useState({ hasError: false, errorText: '' });
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const saveAsReport = async () => {
    if (confirmModalOpen) {
      setConfirmModalOpen(false);
    }
    setIsLoading(true);
    await dispatch(saveReport({ isSaveAs: true, reportName: reportNameForSave }));
    setIsLoading(false);
    handleClose();
  };

  const handleSaveProgressButton = async () => {
    const responce = await getIsReportNameExists(reportNameForSave);
    const isReportNameExist = responce.exists;

    if (isReportNameExist) {
      setConfirmModalOpen(true);
    } else {
      saveAsReport();
    }
  };

  const handleReportNameFieldBlur = () => {
    const errorObj = validateReportNameOnBlur(reportNameForSave);
    setError(errorObj);
  };

  return (
    <>
      <Modal
        open={isOpen}
        variant="default"
        onClose={handleClose}
        title={translateString('Save As Report')}
        buttonProps={[
          {
            label: translateString('Cancel'),
          },
          {
            label: translateString('Save'),
            onClick: handleSaveProgressButton,
            disabled: error.hasError,
          },
        ]}
        className={classes.modal}
        disableBackdropClick
      >
        <TextField
          label={translateString('Report Name')}
          placeholder={translateString('Report Name...')}
          name="reportName"
          value={reportNameForSave}
          onChange={(e) => setReportName(e.target.value)}
          onBlur={handleReportNameFieldBlur}
          error={error.hasError}
          helperText={error.hasError ? translateString(error.errorText) : null}
          fullWidth
          required
        />
      </Modal>
      {confirmModalOpen && (
        <Modal
          open={confirmModalOpen}
          className={classes.confirmModal}
          variant="warning"
          onClose={() => setConfirmModalOpen(false)}
          title={translateString('Confirm Save')}
          buttonProps={[
            {
              label: translateString('Cancel'),
            },
            {
              label: translateString('Save'),
              onClick: saveAsReport,
            },
          ]}
          disableBackdropClick
        >
          <p>
            <b>{reportNameForSave} </b>
            {translateString('report already exists. Do you want to overwrite it?')}
          </p>
        </Modal>
      )}
    </>
  );
};

export default SaveAsModal;
